import React from "react";
import "./AboutMeModal.css";
import cross from "./assets/icons/cross.svg";

export default function AboutMeModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="aboutme-modal-backdrop" onClick={onClose}>
      <button className="aboutme-modal-close" onClick={onClose} aria-label="Закрыть окно">
        <img src={cross} alt="Закрыть" className="aboutme-modal-close-icon" />
      </button>
      <div className="aboutme-modal-window" onClick={e => e.stopPropagation()}>
        <h2 className="aboutme-modal-title">About me</h2>
        <div className="aboutme-modal-desc">
          <p>Hello, my name is Ildar Grankin.

            I am a novice Front-end developer. I also work with Reaсt projects and components, on which this site is written. I am ambitious in my approach to the project and like to learn new things unknown to me before. In the future I plan to study Python and TypeScript development.

            In parallel I am fond of design, 3D modeling and music.</p>
        </div>
        <div className="aboutme-modal-bg" />
      </div>
    </div>
  );
}
